<div class="body">
   
    <tr>

        <td class="col-md-1" style="vertical-align: top;">
            Dirección
        </td>
        <td class="col-md-2">
            <input id="direccion" name="direccion" class="form-control" [(ngModel)]="afiliado.direccion" type="text"
                [disabled]="afiliado.deshabilitado" placeholder="dirección." required/>
        </td>

        <td class="col-md-1" style="vertical-align: top;">
            Región
        </td>
        <td class="col-md-2">
            <mat-form-field appearance="outline" class="mat-input">

                <mat-select name="region" #region="ngModel" [(ngModel)]="afiliado.idRegion" required
                (selectionChange)="traeComunas()"  [disabled]="afiliado.deshabilitado">
                    <mat-option *ngFor="let estado of this.afiliado.regiones" [value]="estado.codigo">
                        {{estado.nombre}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </td>
    </tr>
   
    <tr>
        <td class="col-md-1" style="vertical-align: top;">
            Numero
        </td>
        <td class="col-md-2">
            <input id="numero" name="numero" class="form-control" [disabled]="afiliado.deshabilitado"
                [(ngModel)]="afiliado.numero" type="text" (input)="soloNumeros($event)" placeholder="número." required/>
        </td>
        <td class="col-md-1" style="vertical-align: top;">
            Comuna
        </td>
        <td class="col-md-2">
            <mat-form-field appearance="outline" class="mat-input">

                <mat-select name="comuna" #region="ngModel" [(ngModel)]="afiliado.idComuna" required
                    [disabled]="afiliado.deshabilitado">
                    <mat-option *ngFor="let estado of this.afiliado.comunas" [value]="estado.codigo">
                        {{estado.nombre}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </td>
    </tr>
   
    <tr>
        <td class="col-md-1" style="vertical-align: top;">
            Villa/Población/
            Condominio/N° Depto
        </td>
        <td class="col-md-2">
            <input id="descripcionAdicional" name="descripcionAdicional" class="form-control"
                [disabled]="afiliado.deshabilitado" [(ngModel)]="afiliado.descripcionAdicional" type="text"
                placeholder=" Villa/Población/Condominio/N° Depto." />
        </td>
        <td class="col-md-1" style="vertical-align: top;">
        </td>
        <td class="col-md-2">
        </td>
    </tr>

    <tr>
        <td class="col-md-1" style="vertical-align: top;">
            Teléfono Fijo
        </td>
        <td class="col-md-2">
            <input id="telefonoFijo" name="telefonoFijo" class="form-control" [disabled]="afiliado.deshabilitado"
                [(ngModel)]="afiliado.telefonoFijo" type="text" [maxlength]="9" (input)="soloNumeros($event)" placeholder="telefono Fijo" />
        </td>

        <td class="col-md-1" style="vertical-align: top;">
            Teléfono Movil
        </td>
        <td class="col-md-2">
            <input id="telefonoMovil" name="telefonoMovil" class="form-control" [disabled]="afiliado.deshabilitado"
                [(ngModel)]="afiliado.telefonoMovil" type="text" [maxlength]="9" (input)="soloNumeros($event)" placeholder="telefono Movil." />
        </td>
    </tr>
    
    <tr>
        <td class="col-md-1" style="vertical-align: top;">
            Correo
        </td>
        <td class="col-md-2">
            <input class="form-control" name="email" id="email" [(ngModel)]="afiliado.email" type="text" required
                [disabled]="afiliado.deshabilitado" placeholder="Correo principal.">
        </td>

        <td class="col-md-1" style="vertical-align: top;">
            Correo Personal
        </td>
        <td class="col-md-2">
            <input id="emailAlternativo" name="emailAlternativo" class="form-control"
                [disabled]="afiliado.deshabilitado" [(ngModel)]="afiliado.emailPersonal" type="text"
                placeholder="correo alternativo." />
        </td>
    </tr>
   


    <!--/form-->

</div>